<!-- TODO: contentViewMode for mobile needs to hide primary navigation layer -->
<fc-mobile-menu *fcMediaWrapper="'mobile'" #mobileMenu [items]="menuList">
    <div class="fc-main-wrapper">
        <div class="fc-main-navigation fcp-text-body-l">
            <button
                fcp-outlined-button
                (click)="mobileMenu.toggle()"
                color="transparent"
                class="fc-main-navigation-menu-trigger"
            >
                <i class="fc-font-icon fc-font-icon-menu fc-main-navigation-action"></i>
            </button>

            <span class="fc-main-navigation-page-title">{{ activeMenuTitle | async }}</span>
        </div>
        <mat-sidenav-container class="fc-content-platform-container">
            <mat-sidenav
                #cart
                class="fc-download-list-sidenav"
                [mode]="'over'"
                [autoFocus]="false"
                [fixedInViewport]="false"
                fixedTopGap="56"
                position="end"
            >
                <fc-cart type="download-cart"></fc-cart>
            </mat-sidenav>

            <mat-sidenav-content>
                <ng-container *ngTemplateOutlet="ngContent"></ng-container>
            </mat-sidenav-content>
        </mat-sidenav-container>
        <div class="fc-main-toolbar-buttons">
            <ng-container
                *ngIf="toolbarStoresAction | async as toolbarStoresAction"
                [ngTemplateOutlet]="toolbarActionStoresButton"
                [ngTemplateOutletContext]="{
                    $implicit: toolbarStoresAction,
                    chooseStoreModalId: 'choose-store-modal-mobile'
                }"
            ></ng-container>

            <ng-container
                *ngIf="toolbarAction | async as toolbarAction"
                [ngTemplateOutlet]="toolbarActionButton"
                [ngTemplateOutletContext]="{ $implicit: toolbarAction }"
            ></ng-container>
        </div>
    </div>
</fc-mobile-menu>

<div *fcMediaWrapper="'desktop'" class="fc-main-wrapper">
    <nav *ngIf="!contentViewMode" class="fc-main-navigation fcp-text-body-l" (click)="onNavigationClick()">
        <a routerLink="/r/home" class="fc-main-navigation-logo" (click)="onLogoClick()">
            <img src="assets/img/fc_logo_white.svg" alt="Fashion Cloud Logo" />
        </a>
        <div class="fc-main-navigation-menu">
            <a
                *ngFor="let menuItem of menuList"
                routerLinkActive="fc-main-navigation-menu-item--active"
                (click)="onMenuItemClick(menuItem)"
                [routerLink]="menuItem.route.target"
                [queryParams]="menuItem.route.queryParams"
                [queryParamsHandling]="menuItem.route.queryParamsHandling"
                [attr.data-e2e-hook]="menuItem.e2eHook"
                [showForUserPrivileges]="menuItem.privileges"
                class="fc-main-navigation-menu-item"
            >
                {{ menuItem.label | translate }}
            </a>
        </div>
        <div class="fc-main-navigation-actions">
            <fc-faux-input-button
                *ngIf="isRetailer"
                class="fc-main-navigation-action faux-search-input"
                [icon]="{ icon: ['far', 'search'] }"
                (clicked)="onBrandSearchButtonClick()"
                text="{{ 'BRAND_SEARCH_FAUX_SEARCH_INPUT' | translate }}"
            ></fc-faux-input-button>
            <button
                *ngIf="isRetailer"
                fcp-outlined-button
                color="transparent"
                class="fc-main-navigation-action fc-main-navigation-action-button"
                data-e2e-hook="main-navigation-download-button"
                (click)="onDownloadListClick($event)"
            >
                <fcp-icon-svg [icon]="iconNameMap.ArrowBottom"></fcp-icon-svg>

                <fcp-badge
                    *ngIf="downloadsCount | async as count"
                    class="fc-main-navigation-action-counter fcp-text-counter"
                    [text]="count > 999 ? '999' : count"
                    color="promotion"
                    size="s-round"
                ></fcp-badge>
            </button>
            <button
                *ngIf="isRetailer"
                fcp-outlined-button
                color="transparent"
                class="fc-main-navigation-action fc-main-navigation-action-button"
                data-e2e-hook="main-navigation-shopping-cart-button"
                (click)="openShoppingCart()"
                [ngClass]="{ 'fc-main-navigation-action--active': isRouteActive('shopping-cart') }"
            >
                <fcp-icon-svg [icon]="iconNameMap.ShoppingCart"></fcp-icon-svg>

                <fcp-badge
                    *ngIf="shoppingCartCount | async as count"
                    class="fc-main-navigation-action-counter fcp-text-counter"
                    [text]="count > 999 ? '999' : count"
                    color="promotion"
                    size="s-round"
                ></fcp-badge>
            </button>
            <fcp-menu
                class="fc-main-navigation-action"
                variant="outlined"
                color="transparent"
                menuStyle="subtle"
                menuSize="large"
                [list]="settingsListForMenu | async"
                (menuOpened)="onSettingsMenuOpened()"
                (menuClosed)="onSettingsMenuClosed()"
                (menuItemTriggered)="onMenuItemTriggered($event)"
                [ngClass]="{ 'fc-main-navigation-action--active': isSettingsOpen }"
                data-e2e-hook="main-navigation-setting-menu-button"
            >
                <fcp-icon-svg [icon]="iconNameMap.Cog" class="fc-main-navigation-action"></fcp-icon-svg>
            </fcp-menu>
        </div>
    </nav>
    <nav *ngIf="isToolbarVisibleForDesktop | async" class="fc-main-toolbar">
        <div class="fc-main-toolbar-links">
            <a
                *ngFor="let toolbarLink of toolbarLinks | async"
                [routerLink]="toolbarLink.route.target"
                class="fc-main-toolbar-link fcp-text-body-m"
                routerLinkActive="fc-main-toolbar-link--active"
                [queryParams]="toolbarLink.route.queryParams"
                [queryParamsHandling]="toolbarLink.route.queryParamsHandling"
                [routerLinkActiveOptions]="
                    toolbarLink.route.routerLinkActiveOptions || {
                        queryParams: 'ignored',
                        matrixParams: 'exact',
                        paths: 'subset',
                        fragment: 'exact'
                    }
                "
                [attr.data-e2e-hook]="toolbarLink.e2eHook"
                [showForUserPrivileges]="toolbarLink.privileges"
                (click)="onToolbarItemClick(toolbarLink)"
            >
                {{ toolbarLink.label | translate | titlecase }}
            </a>
        </div>

        <div class="fc-main-toolbar-buttons">
            <ng-container
                *ngIf="toolbarStoresAction | async as toolbarStoresAction"
                [ngTemplateOutlet]="toolbarActionStoresButton"
                [ngTemplateOutletContext]="{
                    $implicit: toolbarStoresAction,
                    chooseStoreModalId: 'choose-store-modal-desktop'
                }"
            ></ng-container>

            <ng-container
                *ngIf="toolbarAction | async as toolbarAction"
                [ngTemplateOutlet]="toolbarActionButton"
                [ngTemplateOutletContext]="{ $implicit: toolbarAction }"
            ></ng-container>
        </div>
    </nav>
    <mat-sidenav-container class="fc-content-platform-container">
        <mat-sidenav
            #cart
            class="fc-download-list-sidenav"
            [mode]="'over'"
            [autoFocus]="false"
            [fixedInViewport]="false"
            fixedTopGap="56"
            position="end"
        >
            <fc-cart type="main-content-drawer"></fc-cart>
        </mat-sidenav>

        <mat-sidenav-content>
            <div class="fc-content-wrapper">
                <div class="fc-content-wrapper-container">
                    <ng-container *ngTemplateOutlet="ngContent"></ng-container>
                </div>
                <fc-main-navigation-summary-bar></fc-main-navigation-summary-bar>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>

<ng-template #ngContent>
    <div class="fc-main-wrapper-content">
        <ng-content></ng-content>
    </div>
</ng-template>

<ng-template #toolbarActionStoresButton let-storesAction let-chooseStoreModalId="chooseStoreModalId">
    <button
        class="fcp-text-body-m fc-main-toolbar-action-trigger fc-main-store-button"
        fcp-button
        color="transparent"
        (click)="displayStoresDropdown()"
        [showForUserPrivileges]="storesAction.privileges"
        [attr.data-e2e-hook]="storesAction.e2eHook"
        id="stores-dropdown"
    >
        <span class="fc-main-toolbar-action">
            <fcp-icon-svg
                *ngIf="storesAction.icon"
                [icon]="storesAction.icon"
                [color]="fcpIconSVGColors.NeutralDark"
            ></fcp-icon-svg>
            {{ storesAction.label | translate }}
            <span *ngIf="storeCount" class="fc-main-toolbar-action-counter fcp-text-counter">{{ storeCount }}</span>
        </span>
        <store-dropdown
            class="fc-main-store-button-dropdown"
            [isDisplayed]="displayStoreDropdownToggle"
            [title]="'ORDER.STORES.DROPDOWN_TITLE' | translate"
            [buttonTitle]="'ORDER.STORES.EDIT' | translate"
            (storeCount)="setStoreCounter($event)"
            (hideDropdown)="displayStoresDropdown()"
            [chooseStoreModalId]="chooseStoreModalId"
        >
        </store-dropdown>
    </button>
</ng-template>

<ng-template #toolbarActionButton let-action>
    <button
        class="fcp-text-body-m fc-main-toolbar-action-trigger"
        [ngClass]="{
            'fc-main-toolbar-action-trigger--active': isRouteActive(action?.route?.target)
        }"
        fcp-button
        color="transparent"
        (click)="action.actionHandler()"
        [showForUserPrivileges]="action.privileges"
        [attr.data-e2e-hook]="action.e2eHook"
    >
        <span class="fc-main-toolbar-action">
            <fcp-icon-svg
                *ngIf="action.icon"
                [icon]="action.icon"
                [color]="fcpIconSVGColors.NeutralDark"
            ></fcp-icon-svg>
            {{ action.label | translate }}
            <span
                *ngIf="action.counter && action.counter | async as count"
                class="fc-main-toolbar-action-counter fcp-text-counter"
                >{{ count > 999 ? '999' : count }}</span
            >
            <span *ngIf="action.counterFn?.()" class="fc-main-toolbar-action-counter fcp-text-counter">{{
                action.counterFn() > 999 ? '999' : action.counterFn()
            }}</span>
        </span>
    </button>
</ng-template>
